import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { PersonService } from './person.service';
import { IPerson } from '../typing/person.interface';

@Injectable({
    providedIn: 'root'
})
export class PersonSelectorService {
    additionalParams: Params = {};

    constructor(private personService: PersonService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        const params = { sortBy: 'id:DESC', ...this.additionalParams, ...query };
        return this.personService.getList(params)
            .pipe(map(response => this.transformData(response, this.additionalParams['status'])));
    }

    transformData(paginatedResponse: IPaginatedResponse<IPerson>, status: string | undefined): IPaginatedResponse<ILabelValue> {
        if (status) {
            paginatedResponse.data = paginatedResponse.data.filter(person => person.status === status);
        }

        const transformedData = paginatedResponse.data.map(person => ({
            label: `${person.firstName} ${person.lastName}`,
            value: person.id,
            tooltip: this.getTooltip(person),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.personService.getPerson(Number(optionValue)).pipe(
            filter(person => !!person),
            map(person => ({
                label: `${person.firstName} ${person.lastName}` as string,
                value: person.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: IPerson): string {
        return (value.firstName ? value.firstName : '') + (value.id ? '; id:' + value.id : '') ;
    }

}
